import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllCourses({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.getAllCourses);
    yield put(actions.getAllCoursesSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllCoursesFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

//Edit Tables
function* editCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.editCourses, payload);
    console.log(result);
    yield put(actions.editCourseSuccess(result.data));
    toast.success("Edit Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    console.log(error);
    yield put(actions.editCourseFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

function* restrictCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.restrictCourses, payload);
    yield put(actions.restrictCourseSuccess(result.data));
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.restrictCourseFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

function* asqueraCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.asquaraCourses, payload);
    yield put(actions.asqueraCourseSuccess(result.data));
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.asqueraCourseFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

function* activeCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.activeCourses, payload);
    yield put(actions.activeCourseSuccess(result.data));
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.activeCourseFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

// create
function* createCourse(formData) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.createCourses, formData.payload);
    yield put(
      actions.createCourseSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action();
  } catch (error) {
    yield put(actions.createCourseFail());
    toast.success(error.data.message.toString());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

function* deleteCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.deleteCourse, payload);

    yield put(actions.deleteCourseSuccess(payload));

    toast.success("Deleted Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.deleteCourseFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

function* approveStudentEnrollCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.approveStudentEnrollRequest, payload);
    yield put(actions.approveStudentEnrollCourseSuccess(result.data));
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.approveStudentEnrollCourseFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

function* rejectStudentEnrollCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.rejectStudentEnrollRequest, payload);
    yield put(actions.rejectStudentEnrollCourseSuccess(result.data));
    toast.success("Rejected Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.rejectStudentEnrollCourseFail());
    toast.error(error.response);
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}

function* getAllEnrollCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.getAllEnrollCourse, payload);
    yield put(actions.getAllEnrollCourseSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllEnrollCourseFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}
export default function* CourseSaga() {
  yield takeLatest(Types.GET_COURSES_REQUEST, getAllCourses);
  yield takeLatest(Types.GET_STUDENT_ENROLL_COURSE_REQUEST, getAllEnrollCourse);

  yield takeLatest(
    Types.APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_REQUEST,
    approveStudentEnrollCourse
  );

  yield takeLatest(
    Types.REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_REQUEST,
    rejectStudentEnrollCourse
  );
  
  yield takeLatest(Types.EDIT_COURSE_REQUEST, editCourse);
  yield takeLatest(Types.RESTRICT_COURSE_REQUEST, restrictCourse);
  yield takeLatest(Types.ACTIVE_COURSE_REQUEST, activeCourse);
  yield takeLatest(Types.ASQUARA_COURSE_REQUEST, asqueraCourse);

  yield takeLatest(Types.CREATE_COURSE_REQUEST, createCourse);
  yield takeLatest(Types.DELETE_COURSE_REQUEST, deleteCourse);
}
